import React, { useState, useMemo, useCallback, createRef } from "react";
import moment from 'moment';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import Button from "../../../shared/controls/button";
import { AG_GRID_LOCALE_ES } from "../../../shared/language";
import { cloneDeep } from "lodash";
import { RequisitionDetailLeft } from "./style";
import ImageWithCheckMark from "../../../shared/component/image-with-check-mark";
import { getUrlsEnv } from "../../../shared/backend-api";
import { DoubleEquipment, Equipment, Truck, TruckDoubleEquipment, TruckEquipment } from "../../../shared/icons/assemble";
import { AssembleAvatar } from "../../assemble/assemble-avatar";
import CopyIcon from '../../../shared/icons/copy-icon';
import ReactTooltip from "react-tooltip";
import { validatePerm } from "../../../shared/utils";

const filterRequisitionCreation = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    let dates = [];

    (cellValue || []).map( item => {
      try {
        let m = moment(item.created || item.event_date || item);
        m.set({hour:0,minute:0,second:0,millisecond:0});

        dates.push(m.unix());
      } catch(e) {
        console.log(`Error de convertir fecha ${e}`);
      }
    });

    let result = -1;

    dates.map(item => {
      if (`${filterLocalDateAtMidnight.getTime()}`.includes(`${item}`)) {
        result = 0;
        return;
      }

      if (moment(item).isBefore(moment(filterLocalDateAtMidnight.getTime()))) {
        result = -1;
        return;
      }

      if (moment(item).isAfter(moment(filterLocalDateAtMidnight.getTime()))) {
        result = 1;
        return;
      }
    });

    return result;
  }
};

const filterLastUpdate = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    let date = null;

    try {
      let m = moment(cellValue.date || cellValue);
      m.set({hour:0,minute:0,second:0,millisecond:0});

      date = m.unix();
    } catch(e) {
      console.log(`Error de convertir fecha ${e}`);
    }

    if (date === null) {
      return -1;
    }

    if (`${filterLocalDateAtMidnight.getTime()}`.includes(`${date}`)) {
      return 0;
    }

    if (moment(date).isBefore(moment(filterLocalDateAtMidnight.getTime()))) {
      return -1;
    }

    if (moment(date).isAfter(moment(filterLocalDateAtMidnight.getTime()))) {
      return 1;
    }

    return 0;
  }
};

const filterParams = {
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    const dateAsString = cellValue;
    if (dateAsString == null) return -1;
    const dateParts = dateAsString.split("/");
    const cellDate = new Date(
      Number(dateParts[2]),
      Number(dateParts[1]) - 1,
      Number(dateParts[0]),
    );

    if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
      return 0;
    }

    if (cellDate < filterLocalDateAtMidnight) {
      return -1;
    }

    if (cellDate > filterLocalDateAtMidnight) {
      return 1;
    }
    return 0;
  }
};

const getValueGetter = (key, params) => {

  let value = '';

  switch(key) {
    case 'assembly':
      let assembly_data = params.data?.assembly || null;

      let vehicles = [];
      (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
        if (item.length > 0) vehicles = vehicles.concat(item);
      })

      value = (assembly_data && vehicles.length) ? `${(vehicles || []).flat().map((e) => e.economic_number)}` : '';
      break;
    case 'fleet_provider':
      value = params.data?.fleet_provider?.orbi_id || '';
      break;
    case 'transport_class_client':
      value = params.data?.transport_class_client?.label || '';
      break;
    case 'transport_class_provider':
      value = params.data?.transport_class_provider?.label || '';
      break;
    case 'from_company':
      value = params.data?.from_company?.orbi_id || '';
      break;
    case 'to_company':
      value = params.data?.to_company?.orbi_id || '';
      break;
    case 'trip_started':
      value = params.data?.trip_started?.event_date || null;
    default:
      value = '';
  }

  return value;

}

const reduceDates = (dates) => {

  if (dates) {

    if (dates.length > 1) {
      let date_pivot = dates[0];

      if (date_pivot === null) {
        return [];
      }

      let m = moment(date_pivot);

      let result = dates.filter( item => {
        if (item === null) return false;
        let temp_item = moment(item);
        let diff = Math.abs(m.diff(temp_item, 'seconds'));

        return diff > 60;
      });

      result = [date_pivot].concat(result);

      return result;

    } else {
      return dates;
    }

  }

  return [];

}

const getCellView = (key, params, props) => {
  let view = null;
  let value = '';
  let assembly_data = null;

  let vehicles = [];
  let equipments = [];

  let is_able_to_edit = false;

  switch(key) {
    case 'type':
      view = <RequisitionDetailLeft>{`${(params.data?.type || '')}`}</RequisitionDetailLeft>
      break;
    case 'containers':
      value = (params.data?.type || '') === 'FTL' ?  (params.data?.container_ids || []).length > 1 ? 'Full' : 'Sencillo' : ''
      view = <RequisitionDetailLeft>{value}</RequisitionDetailLeft>
      break;
    case 'trip_signature':
      let signature = params.data?.trip_signature || '';

      if (signature !== '') {
        view = <RequisitionDetailLeft> 
          <div className="description-action" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            props.handleChange({
              target: {
                name: "trip_selected",
                value: params.data
              }
            });
          }}>
            {signature}
          </div>
          <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            
            navigator.clipboard.writeText(signature); 
          }}/>
        </RequisitionDetailLeft>
      } else {
        view = <div/>
      }

      break;
    case 'order_code':
      view = <RequisitionDetailLeft>
        <div className="description-action" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          props.handleChange({
            target: {
              name: "order_selected",
              value: params.data
            }
          });
        }}>
          {`${params.data.order_code || ''}`}
        </div>
        <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          
          navigator.clipboard.writeText(params.data.order_code); 
        }}/>
      </RequisitionDetailLeft>
      break;
    case 'assembly':
      assembly_data = params.data?.assembly || null;

      vehicles = [];
      (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
        if (item.length > 0) vehicles = vehicles.concat(item);
      })

      equipments = [];
      (Object.values(assembly_data?.equipments || {}) || []).map( item => {
        if (item.length > 0) equipments = equipments.concat(item);
      })

      view = <RequisitionDetailLeft>
        {
            assembly_data && (
              vehicles.length
                ? equipments.length
                  ? vehicles.length > 1
                    ? <TruckDoubleEquipment />
                    : <TruckEquipment />
                  : <Truck />
                : equipments.length
                  ? equipments.length > 1
                    ? <DoubleEquipment />
                    : <Equipment />
                  : <></>)
          }
          {"   "}
          {
            assembly_data
            && (vehicles.length
              ? (
                <div style={{marginLeft: 8}}>{
                  (vehicles || [])
                    .flat()
                    .map((e) => e.economic_number)
                }</div>
              )
              : "-")
          }
      </RequisitionDetailLeft>
      break;
    case 'fleet_provider':
      let logo_provider = params.data?.fleet_provider || null;

      view = <RequisitionDetailLeft>
        <ImageWithCheckMark
          src={getUrlsEnv().files.concat(logo_provider?.logo || '')}
          width={30}
          isCheckMark={logo_provider?.verification_status === 3}
          customStyle={{
            width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 5
          }}
          type={logo_provider?.type_id || 0}
          no_image={logo_provider === null}
        />

        <div>{params.data?.fleet_provider?.orbi_id || ''}</div>
      </RequisitionDetailLeft>
      break;
    case 'eta_unloading':
    case 'eta_loading':
    case 'containers_leave_destination':
    case 'containers_entry_destination':
    case 'containers_leave_origin':
    case 'containers_entry_origin':
    case 'containers_arrival_destination':
    case 'containers_arrival_origin':

      let event_dates = [];
      
      try {
        event_dates = (params.value || []).map(item => item?.event_date || item).filter( item => item !== null);
        event_dates = reduceDates(event_dates);
      } catch (e) {
        console.log(e);
      }
      
      if (event_dates.length > 0) {
        view = <RequisitionDetailLeft style={{flexDirection: 'column', alignItems: 'start'}}>
        {
          event_dates.map( (event_date, i) => {
            return <div key={`status-${i}`} style={{height: 16}}>{ event_date ? `${moment(event_date).format('DD/MM/YYYY HH:mm')}` : '-'}</div>
          })
        }
        </RequisitionDetailLeft>
      } else {
        view = <RequisitionDetailLeft>{'-'}</RequisitionDetailLeft>
      }

      break;
    case 'trip_started':
      view = <div style={{lineHeight: 'normal', height: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        {
          (params.data?.trip_started?.event_date || null) ?
          <div style={{fontSize: 13, height: 18}}>{`${moment(params.data.trip_started.event_date, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm')}`}</div> :
          <div>{'-'}</div>
        }
      </div>
      break;
    case 'transport_class_client':

      if ((props.currentCompany?.type?.id || 0) === 3) {
        is_able_to_edit = (params.data?.to_facility?.company?.type_id || 0) === 3;
      } else {
        is_able_to_edit = (props.currentCompany?.id || 0) === (params.data?.to_company?.id || 0);
      }

      view = <RequisitionDetailLeft>
        {params.data?.transport_class_client?.label || ''}
        {
          is_able_to_edit && 
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
            onClick={() => {
              props.handleChange({
                target: {
                  name: "edit_client_transport_class_order",
                  value: params.data
                }
              });
            }}
          />
        }
      </RequisitionDetailLeft>

      break;
    case 'transport_class_provider':
      
      if ((props.currentCompany?.type?.id || 0) === 3) {
        is_able_to_edit = (params.data?.from_facility?.company?.type_id || 0) === 3;
      } else {
        is_able_to_edit = (props.currentCompany?.id || 0) === (params.data?.from_company?.id || 0);
      }

      view = <RequisitionDetailLeft>
        {params.data?.transport_class_provider?.label || ''}
        {
          is_able_to_edit && 
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
            onClick={() => {
              props.handleChange({
                target: {
                  name: "edit_provider_transport_class_order",
                  value: params.data
                }
              });
            }}
          />
        }
      </RequisitionDetailLeft>
      break;
    case 'actions':
      view = <RequisitionDetailLeft><img style={{height: 25, width: 25}} alt="" className="logo" src="/images/dots.png" /></RequisitionDetailLeft>
      break;
    case 'user':
      view = <RequisitionDetailLeft>{params.value?.name || ''}</RequisitionDetailLeft>
      break;
    case 'requisitions':
      view = <RequisitionDetailLeft>
        {
          (params.value || []).map( item => {
            return <div key={`requisition-${item.id}`}>{`${item.code} - ${moment(item.created).format('DD/MM/YYYY')}`}</div>
          })
        }
      </RequisitionDetailLeft>
      break;
    case 'origin_name':
      view = <RequisitionDetailLeft>{params.data?.from_facility?.name || '-'}</RequisitionDetailLeft>
      break;
    case 'destiny_name':
      view = <RequisitionDetailLeft>{params.data?.to_facility?.name || '-'}</RequisitionDetailLeft>
      break;
    case 'from_company':
      view = <RequisitionDetailLeft>
        
        <ImageWithCheckMark
          src={getUrlsEnv().files.concat(params.data?.from_company?.logo?.substring(1) || '')}
          width={30}
          isCheckMark={params.data?.from_company?.verification_status === 3}
          customStyle={{
            width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 12, marginTop: 8
          }}
          isCo={true}
        />
        
        <div>{params.data?.from_company?.orbi_id || ''}</div>
      </RequisitionDetailLeft>
      break;
    case 'to_company':
        view = <RequisitionDetailLeft>
          
          <ImageWithCheckMark
            src={getUrlsEnv().files.concat(params.data?.to_company?.logo?.substring(1) || '')}
            width={30}
            isCheckMark={params.data?.to_company?.verification_status === 3}
            customStyle={{
              width: 30, height: 30, borderRadius: '50%', position: 'relative', marginRight: 12, marginTop: 8
            }}
            isCo={true}
          />
          
          <div>{params.data?.to_company?.orbi_id || ''}</div>
        </RequisitionDetailLeft>
        break;
    case 'appointment_unloading_date':
      let to_company = params.data?.to_facility?.company || {}

      if (params.trip_status && [6,7].includes(params.trip_status.id) ) {

        view = <RequisitionDetailLeft>
          {
            params.value ? <div>{moment(params.value).format('DD/MM/YYYY HH:mm')}</div> : <div>{'-'}</div>
          }
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "not-allowed", marginLeft: 10, width: 21, height: 21, opacity: 0.5 }}
            data-tip
            data-for={`appointment_unloading_date_error_${params.data.order_id}`}
            onMouseEnter={(e) => {
              ReactTooltip.hide();
              ReactTooltip.show(e.currentTarget);
            }}
            onMouseLeave={() => {
              ReactTooltip.hide();
            }}
          />
          <ReactTooltip
            id={`appointment_unloading_date_error_${params.data.order_id}`}
            className='eta-tooltip-content'
            event="focusin"
            eventOff="focusout"
            place="left"
          > 
            {
              <div style={{lineHeight: 'normal'}}>{ 'El viaje no está en estatus para realizar la acción.' }</div>
            }
          </ReactTooltip>
        </RequisitionDetailLeft>

      } else if ([2,3].includes(props.currentCompany?.type?.id || 0)) {
        view = <RequisitionDetailLeft>
          {
            params.value ? <div>{moment(params.value).format('DD/MM/YYYY HH:mm')}</div> : <div>{'-'}</div>
          }
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
            onClick={() => {
              props.handleChange({
                target: {
                  name: "modify-appointment-unloading",
                  value: {
                    data: {
                      code: params.data?.order_code || '', 
                      logo: getUrlsEnv().files.concat(to_company.logo?.substring(1) || ''),
                      maneuver: 'Descarga',
                    },
                    date: params.data?.appointment_unloading_date,
                    facility_id: params.data?.to_facility?.id || 0,
                    order_id: params.data?.order_id || 0,
                    trip_details: {
                      tags: []
                    }
                  }
                }
              });
            }}
          />
          {
            params.value &&
            <img
              alt=""
              src="/images/bin.png"
              style={{ cursor: "pointer", marginLeft: 10}}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: "cancel-appointment-unloading",
                    value: params.data
                  }
                });
              }}
            />
          }
        </RequisitionDetailLeft>
      } else {
        view = <RequisitionDetailLeft>
          {
            params.value ? <div>{moment(params.value).format('DD/MM/YYYY HH:mm')}</div> : <div>{'-'}</div>
          }
        </RequisitionDetailLeft>
      }
      break;
    case 'appointment_loading_date':
      let from_company = params.data?.from_facility?.company || {}

      if (params.trip_status && [6,7].includes(params.trip_status.id) ) {

        view = <RequisitionDetailLeft>
          {
            params.value ? <div>{moment(params.value).format('DD/MM/YYYY HH:mm')}</div> : <div>{'-'}</div>
          }
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "not-allowed", marginLeft: 10, width: 21, height: 21, opacity: 0.5 }}
            data-tip
            data-for={`appointment_loading_date_error_${params.data.order_id}`}
            onMouseEnter={(e) => {
              ReactTooltip.hide();
              ReactTooltip.show(e.currentTarget);
            }}
            onMouseLeave={() => {
              ReactTooltip.hide();
            }}
          />
          <ReactTooltip
            id={`appointment_loading_date_error_${params.data.order_id}`}
            className='eta-tooltip-content'
            event="focusin"
            eventOff="focusout"
            place="left"
          > 
            {
              <div style={{lineHeight: 'normal'}}>{ 'El viaje no está en estatus para realizar la acción.' }</div>
            }
          </ReactTooltip>
        </RequisitionDetailLeft>

      } else if ([2,3].includes(props.currentCompany?.type?.id || 0)) {
        view = <RequisitionDetailLeft>
          {
            params.value ? <div>{moment(params.value).format('DD/MM/YYYY HH:mm')}</div> : <div>{'-'}</div>
          }
          <img
            alt=""
            src="/images/edit.png"
            style={{ cursor: "pointer", marginLeft: 10, width: 21, height: 21 }}
            onClick={() => {
              props.handleChange({
                target: {
                  name: "modify-appointment-loading",
                  value: {
                    data: {
                      code: params.data?.order_code || '', 
                      logo: getUrlsEnv().files.concat(from_company.logo?.substring(1) || ''),
                      maneuver: 'Carga',
                    },
                    date: params.data?.appointment_loading_date,
                    facility_id: params.data?.from_facility?.id || 0,
                    order_id: params.data?.order_id || 0,
                    trip_details: {
                      tags: []
                    }
                  }
                }
              });
            }}
          />
          {
            params.value &&
            <img
              alt=""
              src="/images/bin.png"
              style={{ cursor: "pointer", marginLeft: 10}}
              onClick={() => {
                props.handleChange({
                  target: {
                    name: "cancel-appointment-loading",
                    value: params.data
                  }
                });
              }}
            />
          }
        </RequisitionDetailLeft>
      } else {
        view = <RequisitionDetailLeft>
          {
            params.value ? <div>{moment(params.value).format('DD/MM/YYYY HH:mm')}</div> : <div>{'-'}</div>
          }
        </RequisitionDetailLeft>
      }
      
      break;
    case 'trip_created':
      if (params.value) {
        view = <RequisitionDetailLeft>
          <div>{moment(params.value).format('DD/MM/YYYY')}</div>
        </RequisitionDetailLeft>
      } else {
        view = <div>{'-'}</div>
      }
      break;
    case 'order_created':
      if (params.value) {
        view = <RequisitionDetailLeft>
          <div>{moment(params.value).format('DD/MM/YYYY')}</div>
        </RequisitionDetailLeft>
      } else {
        view = <div>{'-'}</div>
      }
      break;
    case 'last_update_order':
    case 'last_update_trip':
      if (params.value && params.value.date) {
        view = <RequisitionDetailLeft>
          <div>{moment(params.value.date).format('DD/MM/YYYY')}</div>
        </RequisitionDetailLeft>
      } else {
        view = <div>{'-'}</div>
      }
    break;
    case 'requisition_ids':
      view = <RequisitionDetailLeft>
        {(params.data.requisitions || []).map(item => `${item.id}`).join(', ')}
      </RequisitionDetailLeft>
    break;
    case 'requisition_codes':
      view = <RequisitionDetailLeft>
        {(params.data.requisitions || []).map(item => `${item.code}`).join(', ')}
        <CopyIcon className="copy-icon-style" fill={"#000000"} height="16px" width="16px" onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          
          navigator.clipboard.writeText((params.data.requisitions || []).map(item => `${item.code}`).join(', ')); 
        }}/>
      </RequisitionDetailLeft>
    break;
    case 'tags_client_description':
      view = <RequisitionDetailLeft>
        {
          (params.data?.tags_client || []).map( tag => {
            return(
              <div
                key={`tag-${tag.id}`}
                style={{
                  backgroundColor: tag.color,
                  display: 'flex',
                  height: 25,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingLeft: 4,
                  paddingRight: 4,
                  color: 'white',
                  fontSize: 11,
                  borderRadius: 8,
                  marginRight: 8
                }}
              >
                {tag.title}
              </div>
            );
          })
        }
      </RequisitionDetailLeft>
      break;
    case 'tags_provider_description':
      view = <RequisitionDetailLeft>
        {
          (params.data?.tags_provider || []).map( tag => {
            return(
              <div
                key={`tag-${tag.id}`}
                style={{
                  backgroundColor: tag.color,
                  display: 'flex',
                  height: 25,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingLeft: 4,
                  paddingRight: 4,
                  color: 'white',
                  fontSize: 11,
                  borderRadius: 8,
                  marginRight: 8
                }}
              >
                {tag.title}
              </div>
            );
          })
        }
      </RequisitionDetailLeft>
      break;
    case 'order_status':
      let order_status = params.data?.order_status || null;
      
      if (order_status) {
        view = <div style={{lineHeight: 'normal', height: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
          {
            // <div style={{fontSize: 13, height: 18}}>{`${order_status.description} ${moment(order_status.event_date, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm')}`}</div>
            <div style={{fontSize: 13, height: 18}}>{`${order_status.description}`}</div>
          }
        </div>
      } else {
        view = <div>{''}</div>
      }
      break;
    case 'trip_status':
      let trip_status = params.data?.trip_status || null;
      if (trip_status) {
        view = <div style={{lineHeight: 'normal', height: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        {
          // <div style={{fontSize: 13, height: 18}}>{`${trip_status.description} ${moment(trip_status.event_date, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm')}`}</div>
          <div style={{fontSize: 13, height: 18}}>{`${trip_status.description}`}</div>
        }
      </div>
      } else {
        view = <div>{''}</div>
      }
      break;
    case 'container_status':
      let containers_date = params.data?.container_status || [];
      view = <div style={{lineHeight: 'normal', height: 50, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        {
          containers_date.map( (item, index) => {
            return(
              // <div key={`container-status-${index}`} style={{fontSize: 13, height: 18}}>{`${item.description} ${moment(item.event_date, "YYYY-MM-DD HH:mm:ss").format('DD/MM/YYYY HH:mm')}`}</div>
              <div key={`container-status-${index}`} style={{fontSize: 13, height: 18}}>{`${item.description}`}</div>
            );
          })
        }
      </div>
      break;
    case 'cta':
      const isRow = params.node.data;
      if (!isRow) { view = <div></div>; break; }

      let status_id = params.data?.order_statusid || 0;

      if (status_id === 1) {
        view = <div style={{width: '100%', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Button 
            text={'Confirmar'}
            type='primary small'
            onClick={() => {
              props.handleChange({
                target: {
                  name: "confirm_order",
                  value: params.data
                }
              });
            }}
          />
        </div>
      } else if (status_id === 2) {
        view = <div style={{width: '100%', height: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Button 
            text={'Convertir en Embarque'}
            type='primary small'
            onClick={() => {
              props.handleChange({
                target: {
                  name: "convert-to-trip",
                  value: params.data
                }
              });
            }}
          />
        </div>
      }

      break;
    default:
      view = <div></div>;
  }

  return view;
}

const getCorrectName = (field, default_columns) => {
  let column = default_columns.filter( item => item.field === field);
  return (column && column.length > 0) ? column[0].headerName : null;
}

const filterParamsStatusListFormatter = params => {
  let r = params.value;
  let new_value = '';

  if (r === null) return '';

  if (params.column.colId === 'user') {
    new_value = r.name || '';
  }

  if (['order_status', 'trip_status', 'container_status'].includes(params.column.colId)) {
    if (Array.isArray(r)) {
      if (r.length > 0) {
        new_value = (typeof r[0] === "object") ? r[0].description : r;
      }
    } else {
      new_value = (typeof r === "object") ? r.description : r;
    }
  }

  return new_value;
}

const filterParamsStatusList = {
  valueFormatter: filterParamsStatusListFormatter
}

const getColumnsWithCustomCells = (columns, default_columns, props) => {

  columns.map( (item, index) => {

    let new_header_name = getCorrectName(item.field, default_columns);
    if (new_header_name !== null) {
      columns[index].headerName = new_header_name;
    }

    if (['last_update_order', 'requisitions', 'user', 'order_created', 'from_company', 'to_company', 'origin_name', 'destiny_name', 'appointment_loading_date', 
      'appointment_unloading_date', 'tags_provider_description', 'order_status', 'container_status', 'trip_status', 'cta', 'actions', 'trip_created', 'transport_class_provider', 'transport_class_client', 'trip_started', 
      'containers_entry_origin', 'containers_leave_origin', 'containers_arrival_destination', 'containers_entry_destination', 'containers_leave_destination', 'eta_loading', 'eta_unloading', 
      'containers_arrival_origin', 'fleet_provider', 'assembly', 'order_code', 'requisition_codes', 'trip_signature', 'tags_client_description', 'last_update_trip', 'containers', 'type'].includes(item.field)) {
      columns[index].cellRenderer = params => {
        return getCellView(item.field, params, props)
      }
    }

    if (['user', 'trip_status', 'order_status', 'container_status'].includes(item.field)) {
      columns[index].filterParams = filterParamsStatusList;
      columns[index].filter = "agSetColumnFilter";
      columns[index].valueFormatter = filterParamsStatusListFormatter;
    }

    if (['requisitions', 'containers_arrival_origin', 'containers_entry_origin', 'containers_leave_origin', 'containers_arrival_destination', 'containers_entry_destination', 'containers_leave_destination', 'eta_loading', 'eta_unloading'].includes(item.field)) {
      columns[index].filterParams = filterRequisitionCreation;
      columns[index].filter = "agDateColumnFilter";
    }

    if (['last_update_order', 'order_created', 'trip_created', 'trip_started', 'last_update_trip'].includes(item.field)) {
      columns[index].filterParams = filterLastUpdate;
      columns[index].filter = "agDateColumnFilter";
    }

    if (['transport_class_provider', 'from_company', 'to_company', 'trip_started', 'fleet_provider', 'assembly', 'transport_class_client'].includes(item.field)) {
      columns[index].valueGetter = params => {
        return getValueGetter(item.field, params);
      }
    }

  })

  return columns;
}

const applyNewColumns = (temp_colDefs, props) => {

  if (props.configuration['columns'] !== undefined && typeof props.configuration['columns'] === "object") {

    let temp_columns = props.configuration['columns'];

    if (temp_columns.length === temp_colDefs.length) {
      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);
    }

    try {

      let currentColumns = temp_colDefs.map( item => item.field);
      let currentColumnsSaved = props.configuration['columns'].map( item => item.field);
      let difference = currentColumns.filter(x => !currentColumnsSaved.includes(x));

      let newColumnsToAdd = [];

      temp_colDefs.map( (item, index) => {
        if (difference.includes(item.field)) {
          newColumnsToAdd.push({
            index,
            column: item
          })
        }
      });

      newColumnsToAdd.map( item => {
        temp_columns.splice(item.index, 0, item.column);
      });

      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);

    } catch (error) {
      console.error('Error setting columns definitions', error);

      return getColumnsWithCustomCells(temp_columns, temp_colDefs, props);
    }
  }
}

export const OrderTableView = (props) => {

  const gridRef = createRef();
  const [rowData, setRowData] = useState(props.rowData);
  const [called, setCalled] = useState(false);

  let default_columns = [
    { headerName: '', field: 'order_id_checkbox', suppressMenu: true,  minWidth: 80, width: 80, sortable: true, headerCheckboxSelection: true, checkboxSelection: true },
    { headerName: 'Orden', field: 'order_code', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      cellRenderer: params => {
        return getCellView('order_code', params, props)
      }
    },
    { headerName: 'Embarque', field: 'trip_signature', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true,
      cellRenderer: params => {
        return getCellView('trip_signature', params, props)
      }
    },
    { headerName: 'Proveedor', field: 'from_company', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true,
      valueGetter: (params) => {
        return getValueGetter('from_company', params);
      },
      cellRenderer: params => {
        return getCellView('from_company', params, props)
      }
    },
    { headerName: 'Origen', field: 'origin_name', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('origin_name', params, props)
      }
    },
    { headerName: 'ETA Origen', field: 'eta_loading', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('eta_loading', params, props)
      }
    },
    { headerName: 'Cita de Carga', field: 'appointment_loading_date', minWidth: 230, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('appointment_loading_date', params, props)
      }
    },
    { headerName: 'Cliente', field: 'to_company', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true,
      valueGetter: (params) => {
        return getValueGetter('to_company', params);
      },
      cellRenderer: params => {
        return getCellView('to_company', params, props)
      }
    },
    { headerName: 'Destino', field: 'destiny_name', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('destiny_name', params, props)
      }
    },
    { headerName: 'ETA Destino', field: 'eta_unloading', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('eta_unloading', params, props)
      }
    },
    { headerName: 'Cita de Descarga', field: 'appointment_unloading_date', minWidth: 230, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true,
      cellRenderer: params => {
        return getCellView('appointment_unloading_date', params, props)
      }
    },
    { headerName: 'Estatus de Orden', field: 'order_status', minWidth: 290, filter: true, suppressMenu: true, sortable: true, filterParams: filterParamsStatusList, filter: "agSetColumnFilter", valueFormatter: filterParamsStatusListFormatter,
      cellRenderer: params => {
        return getCellView('order_status', params, props)
      }
    },
    { headerName: 'Estatus de Embarque', field: 'trip_status', minWidth: 290, filter: true, suppressMenu: true, sortable: true, filterParams: filterParamsStatusList, filter: "agSetColumnFilter", valueFormatter: filterParamsStatusListFormatter,
      cellRenderer: params => {
        return getCellView('trip_status', params, props)
      }
    },
    { headerName: 'Estatus de Remolques', field: 'container_status', minWidth: 290, filter: true, suppressMenu: true, sortable: true, filterParams: filterParamsStatusList, filter: "agSetColumnFilter", valueFormatter: filterParamsStatusListFormatter,
      cellRenderer: params => {
        return getCellView('container_status', params, props)
      }
    },
    { headerName: 'Acción', field: 'cta', minWidth: 200, suppressMenu: true,
      cellRenderer: params => {
        return getCellView('cta', params, props)
      }
    },
    { headerName: 'Opciones', field: 'actions', minWidth: 200, suppressMenu: true, tooltipField: 'actions',
      cellRenderer: params => {
        return getCellView('actions', params, props)
      }
    },
    { headerName: 'Transportista', field: 'fleet_provider', minWidth: 60, suppressMenu: true, sortable: true, filter: 'agTextColumnFilter',
      valueGetter: (params) => {
        return getValueGetter('fleet_provider', params);
      },
      cellRenderer: params => {
        return getCellView('fleet_provider', params, props)
      }
    },
    { headerName: 'Ensamble', field: 'assembly', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true, tooltipField: 'assembly',
      valueGetter: (params) => {
        return getValueGetter('assembly', params);
      },
      cellRenderer: params => {
        return getCellView('assembly', params, props)
      }
    },
    { headerName: 'Inicio de Viaje', field: 'trip_started', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterLastUpdate,
      valueGetter: (params) => {
        return getValueGetter('trip_started', params);
      },
      cellRenderer: params => {
        return getCellView('trip_started', params, props)
      }
    },
    { headerName: 'Llegada a Origen', field: 'containers_arrival_origin', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('containers_arrival_origin', params, props)
      }
    },
    { headerName: 'Entrada a Origen', field: 'containers_entry_origin', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('containers_entry_origin', params, props)
      }
    },
    { headerName: 'Salida de Origen', field: 'containers_leave_origin', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('containers_leave_origin', params, props)
      }
    },
    { headerName: 'Llegada de Destino', field: 'containers_arrival_destination', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('containers_arrival_destination', params, props)
      }
    },
    { headerName: 'Entrada a Destino', field: 'containers_entry_destination', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('containers_entry_destination', params, props)
      }
    },
    { headerName: 'Salida de Destino', field: 'containers_leave_destination', minWidth: 200, suppressMenu: true, sortable: true, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation,
      cellRenderer: params => {
        return getCellView('containers_leave_destination', params, props)
      }
    },

    //// columnas ocultas

    { headerName: 'Pedido(s)', field: 'requisition_codes', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true, hide: true,
      cellRenderer: params => {
        return getCellView('requisition_codes', params, props)
      }
    },
    { headerName: 'Entregas', field: 'total_deliveries', minWidth: 200, filter: 'agNumberColumnFilter', suppressMenu: true, sortable: true, hide: true },
    { headerName: 'Tipo', field: 'type', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, hide: true,
      cellRenderer: params => {
        return getCellView('type', params, props)
      }
    },
    { headerName: 'Remolques', field: 'containers', minWidth: 220, filter: 'agNumberColumnFilter', suppressMenu: true, sortable: true, hide: true, 
      cellRenderer: params => {
        return getCellView('containers', params, props)
      }
    },
    { headerName: 'Peso Bruto Total', field: 'total_weight', minWidth: 220, filter: 'agNumberColumnFilter', suppressMenu: true, sortable: true, hide: true },
    { headerName: 'Volumen Total', field: 'total_volume', minWidth: 220, filter: 'agNumberColumnFilter', suppressMenu: true, sortable: true, hide: true },
    { headerName: 'Total de SKUs', field: 'skus', minWidth: 200, filter: 'agNumberColumnFilter', suppressMenu: true, sortable: true, hide: true },
    { headerName: 'Total de Piezas', field: 'total_count', minWidth: 200, filter: 'agNumberColumnFilter', suppressMenu: true, sortable: true, hide: true },
    { headerName: 'Clase de Expedición Proveedor', field: 'transport_class_provider', minWidth: 240, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true, hide: true, 
      valueGetter: (params) => {
        return getValueGetter('transport_class_provider', params);
      },
      cellRenderer: params => {
        return getCellView('transport_class_provider', params, props)
      }
    },
    { headerName: 'Clase de Expedición Cliente', field: 'transport_class_client', minWidth: 240, filter: 'agTextColumnFilter', suppressMenu: true, sortable: true, hide: true, 
      valueGetter: (params) => {
        return getValueGetter('transport_class_client', params);
      },
      cellRenderer: params => {
        return getCellView('transport_class_client', params, props)
      }
    },
    { headerName: 'Etiqueta de Proveedor', field: 'tags_provider_description', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, hide: true,
      cellRenderer: params => {
        return getCellView('tags_provider_description', params, props)
      }
    },
    { headerName: 'Etiqueta de Cliente', field: 'tags_client_description', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, hide: true,
      cellRenderer: params => {
        return getCellView('tags_client_description', params, props)
      }
    },
    { headerName: 'Criticidad de Proveedor', field: 'criticality_provider', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, hide: true },
    { headerName: 'Criticidad de Cliente', field: 'criticality_client', minWidth: 200, filter: 'agTextColumnFilter', suppressMenu: true, hide: true },
    { headerName: 'ID Orden', field: 'order_id', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true, hide: true },
    { headerName: 'Creación de Orden', field: 'order_created', minWidth: 230, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true, hide: true,
      cellRenderer: params => {
        return getCellView('order_created', params, props)
      }
    },
    { headerName: 'Última Actualización de la Orden', field: 'last_update_order', minWidth: 250, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true, tooltipField: 'last_update_order', hide: true,
      cellRenderer: params => {
        return getCellView('last_update_order', params, props)
      }
    },
    { headerName: 'ID Embarque', field: 'trip_id', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true, hide: true },
    { headerName: 'Creación del Embarque', field: 'trip_created', minWidth: 250, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true, hide: true,
      cellRenderer: params => {
        return getCellView('trip_created', params, props)
      }
    },
    { headerName: 'Última Actualización del Embarque', field: 'last_update_trip', minWidth: 250, filter: 'agDateColumnFilter', filterParams: filterLastUpdate, suppressMenu: true, sortable: true, tooltipField: 'last_update_trip', hide: true,
      cellRenderer: params => {
        return getCellView('last_update_trip', params, props)
      }
    },
    
    // { headerName: 'Usuario', field: 'user', minWidth: 60, suppressMenu: true, sortable: true, //headerCheckboxSelection: true, checkboxSelection: true, se oculta por mientras
    //   filterParams: filterParamsStatusList, filter: "agSetColumnFilter", valueFormatter: filterParamsStatusListFormatter, tooltipField: 'user',
    //   cellRenderer: params => {
    //     return getCellView('user', params, props)
    //   }
    // },
    // { headerName: 'Fecha de Creación del Pedido', field: 'requisitions', minWidth: 250, filter: 'agDateColumnFilter', filterParams: filterRequisitionCreation, suppressMenu: true, sortable: true,
    //   cellRenderer: params => {
    //     return getCellView('requisitions', params, props)
    //   }
    // },
    // { headerName: 'ID Pedido', field: 'requisition_ids', suppressMenu: true, filter: 'agTextColumnFilter', minWidth: 200, sortable: true },
    
  ];

  let new_def = applyNewColumns(cloneDeep(default_columns), props);
    
  if (new_def && new_def.length > 0) {
    default_columns = new_def;
  }

  const [colDefs, setColDefs] = useState(default_columns);

  const defaultColDef = useMemo(() => {
    return {
      resizable: true,
      floatingFilter: true,
      tooltipComponent: params => {

        let columnId = params.column?.colId || '';
        let view = null;

        let vehicles = [];
        let equipments = [];
        let operators = [];

        let finalizeOrderValidation = [3,5,6,7].includes((params.data?.order_statusid || 0));
        let cancelOrderValidation = ![8,9,11].includes((params.data?.order_statusid || 0));

        switch(columnId) {
          case 'assembly':
            let assembly_data = params.data?.assembly || null;

            vehicles = [];
            (Object.values(assembly_data?.vehicles || {}) || []).map( item => {
              if (item.length > 0) vehicles = vehicles.concat(item);
            })

            equipments = [];
            (Object.values(assembly_data?.equipments || {}) || []).map( item => {
              if (item.length > 0) equipments = equipments.concat(item);
            })

            operators = [];
            (Object.values(assembly_data?.operators || {}) || []).map( item => {
              if (item.length > 0) operators = operators.concat(item);
            })

            if (vehicles.length > 0 || equipments.length > 0 || operators.length > 0) {

              view = <div
                style={{
                  backgroundColor: 'black',
                  color: 'white',
                  padding: 10,
                  borderRadius: 10
                }}
              >
                {
                  vehicles.map((e, i) => (
                    <div key={`vehicle-id-${i}`}>
                      <AssembleAvatar
                        fleetTypeId={1}
                        description={`${e.economic_number || ""} - ${e.plates || ""}`}
                        showIcon={true}
                      />
                    </div>
                  ))
                }
                {
                  equipments.map((e, i) => (
                    <div key={`equipment-id-${i}`}>
                      <AssembleAvatar
                        fleetTypeId={2}
                        description={`${e.economic_number || ""} - ${e.plates || ""}`}
                        showIcon={true}
                      />
                    </div>
                  ))
                }
                {
                  operators.map((e, i) => (
                    <div key={`operator-id-${i}`}>
                      <AssembleAvatar
                        fleetTypeId={3}
                        description={`${e.first_name || ""} ${e.last_name || ""}`}
                        showIcon={true}
                      />
                    </div>
                  ))
                }
              </div>
            }
            break;
          case 'user':
            view = <div
              style={{
                backgroundColor: 'black',
                color: 'white',
                padding: 10,
                borderRadius: 10
              }}
            >
              <div>{params.value.email}</div>
              <div>{params.value.user_type}</div>
            </div>
            break;
          case 'last_update_trip':
          case 'last_update_order':
            view = <div
              style={{
                backgroundColor: 'black',
                color: 'white',
                padding: 10,
                borderRadius: 10
              }}
            >
              <div>{moment(params.value.date).format('DD/MM/YYYY')}</div>
              <div>{`${params.value.username} - ${params.value.company}`}</div>
              <div>{params.value.email}</div>
            </div>
            break;
            case 'actions':
              view = <div
              style={{
                backgroundColor: 'black',
                color: 'white',
                padding: 10,
                borderRadius: 10
              }}
            >
              {/* <div
                style={{cursor: 'pointer'}}
                onClick={() => {
                  props.handleChange({
                    target: {
                      name: "entarimar",
                      value: 'Función de entarimar'
                    }
                  })
                }}
              >{'Entarimar'}</div>
              <div style={{height: 8}}/>*/}
              
              <div
                style={ finalizeOrderValidation ? {cursor: 'pointer'} : {color: 'gray'}}
                onClick={() => {
                  if (finalizeOrderValidation) {
                    props.handleChange({
                      target: {
                        name: "finalize-order",
                        value: params.data
                      }
                    });
                  }
                }}
              >{'Finalizar la Orden Sin Datos'}</div>
              <div style={{height: 8}}/>
              <div
                style={ cancelOrderValidation ? {cursor: 'pointer'} : {color: 'gray'}}
                onClick={() => {
                  if (cancelOrderValidation) {
                    props.handleChange({
                      target: {
                        name: "cancel-order",
                        value: params.data
                      }
                    });
                  }
                }}
              >{'Cancelar la Orden'}</div>
              <div style={{height: 8}}/>
              <div
                style={ (params.data?.order_statusid || 0) === 1 ? {cursor: 'pointer'} : {color: 'gray'}}
                onClick={() => {
                  if ((params.data?.order_statusid || 0) === 1) {
                    props.handleChange({
                      target: {
                        name: "convert-to-trip",
                        value: params.data
                      }
                    });
                  }
                }}
              >{'Convertir en Embarque'}</div>
              </div>
            break;
          default:
            view = <div/>
        }

        return view;
      }
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: "left",
    };
  }, []);
  
  const updateAggridConf = (params) => {
    if (called) {
      let config = {
        columns: params.api.getColumnDefs(),
        filter: params.api.getFilterModel()
      };
  
      if (props.setNewFilter) {
        props.setNewFilter(config);
      }
    }
  };

  const onGridReady = useCallback((params) => {

    if (props.allSelected) {
      params.api.selectAll()
    }

    setCalled(true);
    
  }, []);

  return (
    <div>
      <div
        className="ag-theme-alpine"
        style={{ height: 650, marginBottom: 50 }}
      >
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={colDefs}
          enableCellTextSelection={true}
          suppressRowClickSelection={true}
          rowHeight={55}
          rowSelection="multiple"
          localeText={AG_GRID_LOCALE_ES}
          defaultColDef={defaultColDef}
          tooltipShowDelay={500}
          tooltipInteraction={true}
          keepDetailRows={true}
          onGridReady={onGridReady}
          onCellClicked={ params => {
            if (props.isModeSelection) return;
          }}
          gridOptions={{
            sideBar: {
              toolPanels: ['columns', 'filters'],
              position: 'right',
              defaultToolPanel: '',
            },
          }}
          groupDisplayType={"groupRows"}
          rowGroupPanelShow={"always"}
          autoGroupColumnDef={autoGroupColumnDef}
          enableCharts={true}
          enableRangeSelection={true}
          onSelectionChanged ={ params => {
            props.handleChange({
              target: {
                name: "orders_selected",
                value: (params.api?.getSelectedRows() || []).map( item => ({id: item.order_id, code: item.order_code, status: item.order_status}))
              }
            });
          }}
          onFilterChanged={ params => {
            updateAggridConf(params);
          }}
          onColumnMoved={ params => {
            if (params.finished) {
              updateAggridConf(params);
            }
          }}
          onColumnVisible={ params => {
            updateAggridConf(params);
          }} 
        />
      </div>
    </div>
    );
}